export class Vehicle{
    constructor(){
        this.isTruck = true;
    }

    id: number;
    plateNumber: string;
    isTruck: boolean;
    isActive: boolean;
    createdBy: number;
    createdById: number;
    createdDate: string; //dateString
    updatedBy: number;
    updatedDate: string; //dateString
}


// WEBPACK FOOTER //
// ./src/app/models/vehicles/vehicle.ts